/**
 * File cursor.js.
 * Custom cursor element to follow cursor inside splide element.
 */
(function () {
    document.querySelectorAll('.splide').forEach(function (splide) {
        const cursor = splide.querySelector('.slider-cursor');
        if (cursor) {
            splide.addEventListener('mousemove', function (e) {
                const rect = splide.getBoundingClientRect();
                cursor.style.top = `${e.clientY - rect.top}px`;
                cursor.style.left = `${e.clientX - rect.left}px`;
            });
            splide.addEventListener('mouseenter', () => {
                cursor.style.display = 'block';
            });
            splide.addEventListener('mouseleave', () => {
                cursor.style.display = 'none';
            });
        }
    });
}());
